import React, { useImperativeHandle, useState, useRef } from 'react';
import { CompanyDialog } from '@Local/ClubCompany/Dialog/';
import useForkRef from '@Util/hook/useForkRef';

const CompanyDialogBox = React.forwardRef((props, ref) => {
    const dialogRef = useRef(null);
    const combinedRef = useForkRef(ref, dialogRef);
    const [openDialog, setOpenDialog] = useState('');
    const [sourceData, setSourceData] = useState({});
    const refreshRef = useRef(null);

    const doRefresh = () => {
        if (refreshRef.current && typeof refreshRef.current === 'function') {
            const fn = refreshRef.current;
            setTimeout(fn, 300);
        }
    };

    useImperativeHandle(
        combinedRef,
        () => {
            return {
                openCompanyDialog: (targetData, _refreshFn = () => {}) => {
                    setSourceData(targetData || {});
                    setOpenDialog('company');
                    refreshRef.current = _refreshFn;
                },
                closeDialog: () => handleCloseDialog(),
            };
        },
        // eslint-disable-next-line
        []
    );

    const handleCloseDialog = () => {
        setOpenDialog(null);
        setSourceData(null);
        refreshRef.current = null;
    };

    return (
        <React.Fragment>
            <CompanyDialog open={openDialog === 'company'} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
        </React.Fragment>
    );
});

export default CompanyDialogBox;
